import React from 'react';
import PropTypes from 'prop-types';


export const AuthyShape = PropTypes.shape({
  verification_code: PropTypes.string.isRequired,
});

const AuthyMultiStepFormPropTypes = {
  verificationCode: PropTypes.string.isRequired,
  handleVerificationCodeChange: PropTypes.func.isRequired,
};

const AuthyMultiStepForm = ({ verificationCode, handleVerificationCodeChange }) => (
  <>
    <div className="row header-40">
      <div className="col">
        <h2>Authy</h2>
      </div>
    </div>

    <div className="row header-24">
      <div className="col">
        <p>To continue, entered the verification code received below.</p>
      </div>
    </div>

    <div className="row">
      <div className="col">
        <label>
          {'SMS Verification Code: '}
          <input
            type="text"
            name="verification_code"
            value={verificationCode}
            onChange={handleVerificationCodeChange}
          />
        </label>
      </div>
    </div>
  </>
);

AuthyMultiStepForm.propTypes = AuthyMultiStepFormPropTypes;


export default AuthyMultiStepForm;
